<template>
  <div class="top-tab">
    <template v-for="item in list">
      <span class="tab-item">
        <router-link class="list"
                     :to="item.to">
          <span class="name">{{item.name}}</span>
          <span class="num" v-if="item.num">{{item.num}}</span>
        </router-link>
      </span>
    </template>
  </div>
</template>

<script type="text/ecmascript-6">
  export default{
    props: {
      list: {
        type: Array,
      }
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .top-tab
    height: 50px
    background #ffffff
    border-bottom: 1px solid #e4e4e4
    .tab-item
      display: inline-block
      padding: 0 20px
      height: 50px
      text-align: center
      .list
        display: inline-block
        .name
          display: inline-block
          height: 50px
          line-height: 50px
          font-size: 16px
          color: #000
          box-sizing border-box
        .num
          display inline-block
          vertical-align text-bottom
          font-size: 10px
          height: 18px
          line-height: 18px
          border-radius 9px
          padding: 0 6px
          color: #ffffff
          background: red
      .router-link-active .name
        color: #3399ff
        border-bottom: 3px solid #3399ff


</style>



// WEBPACK FOOTER //
// src/components/middlenav/MiddleNav.vue